import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useService } from '../providers/ServiceProvider';

export function useRuleListQuery(queryParams?: { limit?: number; offset?: number }) {
  const client = useService();
  return useQuery<any[], Error>(['rule-list', queryParams], () => client.ruleList(queryParams), {
    keepPreviousData: true
  });
}

export function useRuleCreateMutation() {
  const client = useService();
  const queryClient = useQueryClient();
  return useMutation((rule: { predicate: any; action: any }) => client.ruleCreate(rule), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['rule-list']);
    }
  });
}

export function useRuleReadQuery(ruleId: string) {
  const client = useService();
  return useQuery<any, Error>({
    queryKey: ['rule-read', ruleId],
    queryFn: () => client.ruleRead(ruleId)
  });
}

export function useRuleUpdateMutation(ruleId: string) {
  const client = useService();
  const queryClient = useQueryClient();
  return useMutation((rule: { predicate: any; action: any }) => client.ruleUpdate(ruleId, rule), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['rule-list']);
      await queryClient.invalidateQueries(['rule-read', ruleId]);
    }
  });
}

export function useRuleDestroyMutation() {
  const client = useService();
  const queryClient = useQueryClient();
  return useMutation((ruleId: string) => client.ruleDestroy(ruleId), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['rule-list']);
    }
  });
}
